var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.714 11.1935C23.543 11.3317 20.5242 13.1044 20.5242 17.0462C20.5242 21.6055 24.3655 23.2185 24.4805 23.2584C24.4628 23.3567 23.8702 25.4674 22.4552 27.618C21.1934 29.5106 19.8756 31.4 17.871 31.4C15.8663 31.4 15.3504 30.1865 13.0362 30.1865C10.7809 30.1865 9.97906 31.44 8.14538 31.44C6.31169 31.44 5.03224 29.6888 3.56117 27.5381C1.8572 25.0127 0.480469 21.0894 0.480469 17.3657C0.480469 11.3932 4.20679 8.22562 7.87416 8.22562C9.82281 8.22562 11.4472 9.559 12.6706 9.559C13.8351 9.559 15.6511 8.14574 17.868 8.14574C18.7082 8.14574 21.727 8.22562 23.714 11.1935ZM16.8156 5.61723C17.7324 4.48355 18.381 2.91053 18.381 1.3375C18.381 1.11937 18.3633 0.898165 18.325 0.719971C16.8333 0.778345 15.0585 1.75534 13.9884 3.04878C13.1482 4.04421 12.364 5.61723 12.364 7.21176C12.364 7.4514 12.4023 7.69104 12.42 7.76784C12.5144 7.78628 12.6677 7.80778 12.821 7.80778C14.1594 7.80778 15.8427 6.8738 16.8156 5.61723Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.7aa680654d9ddd7fe424466905991ed9.svg";
export { ForwardRef as ReactComponent };